import styled from 'styled-components';
import { rgba } from 'polished';
import Card from '@material-ui/core/Card';

// CONSTANTS
import { BLACK, SANTAS_GRAY, PORCELAIN, TRANSPARENT } from '@/constants/colors';

export const CardStyled = styled(Card)`
  position: relative;
  overflow: visible;

  .package-card,
  &.package-card {
    padding: 40px 30px;
    border-radius: 6px;
    box-shadow: 0 10px 20px ${rgba(BLACK, 0.1)};
    border-width: 3px;
    border-style: solid;
    border-color: ${TRANSPARENT};

    &--active {
      border-color: ${p => p.theme.palette.primary.main};
    }

    .title {
      transition: color 250ms ease;
    }

    .label {
      position: absolute;
      bottom: calc(100% - 2px);
      left: -3px;
      background-color: ${p => p.theme.palette.primary.main};
      color: ${p => p.theme.palette.primary.contrastText};
      width: calc(100% + 6px);
      padding: 10px;
      border-radius: 6px 6px 0 0;
    }
  }

  .package-card {
    &__price {
      margin: 15px 0 20px;
      line-height: 2.6rem;
      font-weight: 500;

      .price {
        font-size: 2.6rem;
      }

      .period {
        color: ${SANTAS_GRAY};
        font-size: 2rem;
      }
    }

    &__divider {
      max-width: 200px;
      width: 40%;
    }

    &__about {
      margin: 30px 0;
    }

    &__view-channels {
      background-color: ${PORCELAIN};
    }
  }
`;

export default CardStyled;
